import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { TextField, Popover, IconButton, FontIcon } from 'material-ui';
import DayPicker from 'react-day-picker';
import { connect } from 'react-redux';
import uuid from 'node-uuid';
import R from 'ramda';

const propTypes = {
  errorText: PropTypes.string,
  hintText: PropTypes.string,
  onChange: PropTypes.func,
  textFieldStyle: PropTypes.object,
  containerStyle: PropTypes.object,
  closeOnSelect: PropTypes.bool,
  id: PropTypes.string,
  'data-cy': PropTypes.string,
  floatingLabelText: PropTypes.string,
  initialMonth: PropTypes.any,
  renderDay: PropTypes.func,
  value: PropTypes.any,
  locale: PropTypes.string,
  disabledRanges: PropTypes.array,
  enableFrom: PropTypes.any,
  enableTo: PropTypes.any,
  disabled: PropTypes.bool,
};

class DatePicker extends Component {
  constructor(props) {
    super(props);
    moment.locale(props.locale);
    const dateFormat = props.locale && props.locale.toLowerCase() === 'en-us' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    this.state = {
      open: false,
      dateFormat,
      id: props.id || uuid.v1(),
      value: props.value ? moment.utc(props.value).format(dateFormat) : '',
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.locale !== nextProps.locale || this.props.value !== nextProps.value) {
      moment.locale(nextProps.locale);
      const dateFormat = nextProps.locale === 'en-US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
      this.setState({
        open: false,
        dateFormat,
        value: nextProps.value ? moment.utc(nextProps.value).format(dateFormat) : '',
      });
    }
    }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  handleDayClick = (day) => {
    const utcDay = this._getUTCDay(day);
    if (this._checkIfDisabled(day)) {
      alert('This date is not available.');
    } else {
      this.setState({
        value: moment.utc(utcDay).format(this.state.dateFormat),
        open: !this.props.closeOnSelect,
        errorText: '',
      });
      this.props.onChange(moment.utc(utcDay).format());
    }
  };


  _popDayPicker = (e) => {
    const _this = this;
    if (!_this.props.disabled) {
      _this.setState({
        open: true,
        anchorEl: e.currentTarget,
      });
    }
  };

  _getDateObject = string => {
    const { dateFormat } = this.state;
    let monthDayYear = {};
    if (!string) return string;
    const splitArray = string.split('/');
    if (splitArray.length < 3) return string;
    if (!(splitArray[2] && (splitArray[2].length === 2 || splitArray[2].length === 4) )) return string;
    if (dateFormat === 'MM/DD/YYYY') {
      monthDayYear = {
        month: parseInt(splitArray[0], 10) - 1,
        day: splitArray[1],
        year: splitArray[2] && splitArray[2].length === 2 ? `20${splitArray[2]}` : splitArray[2],
      };
    }
    if (dateFormat === 'DD/MM/YYYY') {
      monthDayYear = {
        day: splitArray[0],
        month: parseInt(splitArray[1], 10) - 1,
        year: splitArray[2] && splitArray[2].length === 2 ? `20${splitArray[2]}` : splitArray[2],
      };
    }
    if (monthDayYear.day > 31 || monthDayYear.month > 11) return undefined;
    const newDate = new Date(monthDayYear.year, monthDayYear.month, monthDayYear.day);
    return newDate;
  };

  handleInputChange = (e) => {
    const { value } = e.target;
    this.setState({
      value,
      errorText: '',
    });
  };

  _handleOnBlur = e => {
    const { value } = e.target;
    const updatedValue = this._getDateObject(value);
    if (!value) {
      this.setState({
        value,
        errorText: '',
      });
      this.props.onChange('');
    } else if (updatedValue && moment.isDate(updatedValue) && moment(updatedValue).isValid() && !this._checkIfDisabled(updatedValue)) {
      const utcDay = moment.utc(this._getUTCDay(updatedValue)).format();
      this.setState({
        value: moment(updatedValue).format(this.state.dateFormat),
        errorText: '',
      });
      this.props.onChange(utcDay);
    } else {
      this.setState({ errorText: 'Invalid date.' });
    }
  };

  _isDayInRange = (day, range, inclusive) => {
    if (range.from && range.to) return moment(day).isBetween(range.from, range.to, 'day', inclusive ? '[]' : '()');
    if (range.from) return moment(day).isSame(this._getDateFromUTC(range.from), 'day');
    return false;
  };

  _checkIfDisabled = day => {
    const { disabledRanges, enableFrom, enableTo } = this.props;
    return  (disabledRanges || []).some(range => {
        if (range.from && range.to) return this._isDayInRange(day, range, true);
        return moment(day).isSame(range, 'day');
      }) || moment(day).isBefore(this._getDateFromUTC(enableFrom) || new Date('1000-01-31'), 'day')
      || moment(day).isAfter(this._getDateFromUTC(enableTo) || new Date('11000-01-31'), 'day');
  };

  _getDateFromUTC = date => {
    const dateObject = new Date(date);
    return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
  };
  _getUTCDay = day => new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate()));
  render() {
    const { errorText, hintText, floatingLabelText, textFieldStyle, underlineStyle, containerStyle, initialMonth, id, disabled } = this.props;
    const { value, open, anchorEl, dateFormat } = this.state;
    const selectedDay = this._getDateObject(value);
    return (
      <div style={containerStyle}>
        <div style={{ display: 'inline-block', width: '70%' }}>
          <TextField
            id={this.state.id}
            disabled={disabled}
            data-cy={this.props['data-cy']}
            style={{ height: '48px', ...textFieldStyle }}
            hintStyle={{ top: '15px' }}
            floatingLabelStyle={{ top: '15px' }}
            inputStyle={{ top: '-12px' }}
            errorText={errorText || this.state.errorText}
            value={value}
            hintText={hintText ? hintText : dateFormat}
            floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
            floatingLabelText={floatingLabelText}
            onChange={ this.handleInputChange }
            onBlur={this._handleOnBlur}
            underlineStyle={underlineStyle}
          />
        </div>
        <div style={{ display: 'inline-block', height: '48px', verticalAlign: 'top' }}>
          <FontIcon
            style={{ fontSize: '20px', cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative', top: floatingLabelText ? '22px' : '0' }}
            onClick={this._popDayPicker}
            color={disabled ? '#e0e0e0' : ''}
            className="tc-icon-date_range"
          />
        </div>
        <Popover
          open={open}
          onRequestClose={() => this.setState({ open: false })}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <DayPicker
            ref="daypicker"
            initialMonth={initialMonth ? new Date(this._getDateFromUTC(initialMonth)) : new Date()}
            modifiers={{
              selected: day => moment(selectedDay).isSame(day, 'day'),
              disabled: day => this._checkIfDisabled(day),
            }}
            renderDay={this.props.renderDay}
            onDayClick={ this.handleDayClick }
          />
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = ({ config }) => {
  return {
    locale: config.toJS().locale,
  };
};

DatePicker.propTypes = propTypes;

export default connect(mapStateToProps)(DatePicker);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/date-picker.jsx